import 'mapbox-gl/dist/mapbox-gl.css';

export const mapStyles = {
  light: 'mapbox://styles/mapbox/light-v9',
  dark: 'mapbox://styles/mapbox/dark-v10',
  dmStreets: 'mapbox://styles/digimondo/cjn4e7kzsjv8w2rlc0a574xu4',
  satellite: 'mapbox://styles/mapbox/satellite-v9',
  streets: 'mapbox://styles/mapbox/streets-v11',
};

export const mapsMixin = {
  methods: {
    getMapStyle() {
      const mapStyle = this.$store.state.app.mapStyle || localStorage.getItem('mapStyle') || 1;

      switch (mapStyle) {
        case '1':
          return !this.$store.state.app.UiTheme ? mapStyles.light : mapStyles.dark;
        case '2':
          return mapStyles.satellite;
        case '3':
          return mapStyles.streets;
        case '4':
          return mapStyles.dmStreets;
        default:
          return !this.$store.state.app.UiTheme ? mapStyles.light : mapStyles.dark;
      }
    },
  },
};
